import './App.css';
import Table from './components/table'

function App () {
  return (
    <div className="App">
      <Table />
    </div>
  );
}

export default App;
